module.exports = __webpack_public_path__ + "static/flags/BS-ca034cbd00677970e8ca782ee7a3f1a7.gif";